<template>
  <div>
    <h1 class="page-header">{{ $t('payrollTemplate.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-10">
            <ts-button color="info" outline @click="showForm()">
              {{ $t('addNew') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end"></div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record, index }">
          <td>{{ record.template_name }}</td>
          <td>{{ record.template_type }}</td>
          <td>{{ record.created_date }}</td>
          <td class="text-center">
            <input type="checkbox" class="mt-1" v-model="record.is_override" />
          </td>
          <td class="text-center">
            <a href="" v-tooltip="'Design Template'" class="text-primary mr-2" @click.prevent="designTemlate(record)">
              <i class="fas fa-circle-notch spin" v-if="record.is_design"></i>
              <i class="fas fa-file-signature" v-else></i>
            </a>
            <a href="" v-tooltip="'Upload Template'" class="text-primary mr-2" @click="templateRowValue = record">
              <label for="uploadTemplate" class="text-primary pointer">
                <i class="fas fa-circle-notch spin" v-if="record.is_upload"></i>
                <i class="fas fa-file-upload" v-else></i>
              </label>
            </a>
            <a href="" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
            <a
              href=""
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
      <input
        type="file"
        id="uploadTemplate"
        ref="uploadTemplate"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        @change="uploadTemplate"
        style="display:none"
      />
    </ts-card>
  </div>
</template>

<script>
import * as FileDownload from 'downloadjs'
import { mapState } from 'vuex'
import FormComponent from './form.vue'
import { trim } from 'lodash'
import { Errors } from 'form-backend-validation'

export default {
  name: 'payroll-template',
  components: {
    FormComponent
  },
  data() {
    return {
      loading: false,
      templateRowValue: [],
      file: '',
      errors: new Errors()
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/payrollTemplate', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.payrollTemplate.search
      },
      set(newValue) {
        this.$store.commit('hr/payrollTemplate/SET_SEARCH', newValue)
        this.$store.commit('hr/payrollTemplate/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('payrollTemplate.templateName')
        },
        {
          name: this.$t('payrollTemplate.templateType')
        },
        {
          name: this.$t('payrollTemplate.createdDate')
        },
        {
          name: this.$t('payrollTemplate.override'),
          style: 'width:10%; text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/payrollTemplate/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('hr/payrollTemplate/destroy', record.template_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '80%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    designTemlate(record) {
      record.is_design = true
      this.$store
        .dispatch('hr/payrollTemplate/design', {
          id: record.template_id,
          override: record.is_override
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(response.headers['content-disposition'].indexOf('filename'))
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(errorData => {
          let error = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(errorData)))
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record.is_design = false
        })
    },
    async uploadTemplate() {
      this.file = this.$refs.uploadTemplate.files[0] ? this.$refs.uploadTemplate.files[0] : null
      if (this.file) {
        if (await this.$confirmModal.danger(this.$t('payrollTemplate.areYouSureToUploadTemplate'))) {
          this.templateRowValue.is_upload = true

          let formData = new FormData()
          formData.append('template_file', this.file)

          this.$store
            .dispatch('hr/payrollTemplate/uploadTemplate', {
              id: this.templateRowValue.template_id,
              data: formData
            })
            .then(response => {
              this.$toasted.success(response.message)
              this.$refs.uploadTemplate.value = ''
              this.templateRowValue.is_upload = false
              this.templateRowValue = []
            })
            .catch(error => {
              this.errors = new Errors(error.errors)
              this.$toasted.error(this.errors.has('template_file') ? this.errors.first('template_file') : error.message)
              this.$refs.uploadTemplate.value = ''
              this.templateRowValue.is_upload = false
              this.templateRowValue = []
            })
        }
      } else {
        this.$toasted.info(this.$t('payrollTemplate.noChooseFile'))
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/payrollTemplate/RESET_STATE')
    next()
  }
}
</script>

<style lang="css" scoped>
.pointer {
  cursor: pointer;
}
</style>
